export const getCurrentUser = () => {
    try {
      const userData = localStorage.getItem("userData");
      return userData ? JSON.parse(userData) : null;
    } catch (e) {
      console.error("Error parsing userData:", e);
      return null;
    }
  };
  
  export const getCurrentUserId = () => {
    const user = getCurrentUser();
    return user?._id || user?.id || null; // backend ke hisaab se
  };